import React, { useEffect, useState } from "react";
import * as reportServices from "../../../../services/ReportService";
import { useNavigate } from "react-router-dom";
import PATHS from "../../../../constants/paths";
import ReportDetailView from "./reportDetail.view2";

const ReportDetailContainer = ({ uuid, report }) => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (uuid) {
      reportServices.getReport(uuid).then((result) => {
        setData(result);
      });
    }
  }, [uuid]);

  return <ReportDetailView data={data} report={report} />;
};

ReportDetailContainer.propTypes = {};

export default ReportDetailContainer;
